import cc from "color-convert"
import _ from "lodash"

export const translate = [
  [1, -1],
  [1, 1],
  [-1, 1],
  [-1, -1],
]

export const modifyColor = (hex: string): string => {
  const hsl = cc.hex.hsl(hex)
  return `hsl(${hsl[0]},${hsl[1] - 20}%,${hsl[2] - 10}%)`
}

const hasOnlyBit = (bits) => bits && !(bits & (bits - 1))

const decode = (result) => {
  for (let i = 0; i < 4; ++i) {
    if (result & (1 << i)) return i
  }
  return -1
}

const checkHmi = (result, h) => {
  if (h <= -9) result &= (1 << 1) | (1 << 2)
  else if (h >= 9) result &= 1 << 3
  else result &= 1 << 0
  return result
}

const checkWd = (result, wd) => {
  if (wd > 0) result &= (1 << 2) | (1 << 3)
  else result &= (1 << 0) | (1 << 1)
  return result
}

export const getDominant = (pt: number[]): number => {
  let result = 0x0
  const [a, b, c, d, wd, h] = pt
  const fmat = [a, b, c, d]
  const candidate = []
  let maxPt = _.max(fmat)

  for (let i = 0; i < 4; ++i) {
    if (maxPt === fmat[i]) {
      candidate.push(i)
      result |= 1 << i
    }
  }
  if (hasOnlyBit(result)) return decode(result)
  let newResult

  // 1. HMI
  /*
    1유형 : -8 < x < +8 [양뇌/전뇌형]
    2,3유형 : x < -9 [좌뇌형]
    4 유형 : x > +9 [우뇌형]
     */
  newResult = checkHmi(result, h)
  if (hasOnlyBit(newResult)) return decode(newResult)

  // 2. watching/doing score
  // +:3,4, -:1,2
  newResult = checkWd(result, wd)
  if (hasOnlyBit(newResult)) return decode(newResult)

  // 3. 반대유형
  const opposite = [(candidate[0] + 2) % 4, (candidate[1] + 2) % 4]
  const opp1 = pt[opposite[0]],
    opp2 = pt[opposite[1]]
  if (opp1 > opp2) return candidate[1]
  if (opp1 < opp2) return candidate[0]

  return -1
}
